var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2550,
    y: 1000,
    width: 1189,
    height: 521
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3434.16 1039.73 3512.72 1125.22 3427.23 1203.77 3348.67 1118.28Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3434.16 1039.73 3512.72 1125.22 3427.23 1203.77 3348.67 1118.28Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3434.16 1039.73 3512.72 1125.22 3427.23 1203.77 3348.67 1118.28Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2613 -1015)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3447.06 1139.56C3457.63 1129.85 3455.17 1117.64 3452.04 1105.66 3463.72 1109.79 3475.67 1113.27 3486.24 1103.56L3484.61 1101.78C3482.49 1103.77 3479.98 1105.3 3477.24 1106.27L3450.05 1076.68C3451.25 1074.03 3452.99 1071.66 3455.15 1069.72L3453.51 1067.94C3442.94 1077.65 3445.4 1089.86 3448.53 1101.84 3436.86 1097.71 3424.9 1094.23 3414.33 1103.94 3403.76 1113.65 3406.22 1125.86 3409.35 1137.85 3397.67 1133.72 3385.72 1130.23 3375.15 1139.94L3376.78 1141.73C3378.9 1139.73 3381.41 1138.2 3384.15 1137.23L3411.34 1166.82C3410.14 1169.47 3408.41 1171.84 3406.24 1173.78L3407.88 1175.56C3418.45 1165.85 3415.99 1153.65 3412.86 1141.66 3424.54 1145.79 3436.49 1149.27 3447.06 1139.56ZM3449.11 1079.23 3474.62 1106.99C3467.3 1108.44 3459.45 1105.73 3451.29 1102.82 3449.08 1094.45 3447.05 1086.41 3449.11 1079.23ZM3449.28 1104.67C3451.49 1113.05 3453.53 1121.09 3451.47 1128.27L3425.95 1100.5C3433.28 1099.06 3441.13 1101.76 3449.28 1104.67ZM3423.34 1101.23 3450.52 1130.82C3448.04 1136.13 3443.56 1140.25 3438.06 1142.27L3410.87 1112.69C3413.35 1107.37 3417.83 1103.25 3423.34 1101.23ZM3412.28 1164.27 3386.77 1136.51C3394.1 1135.06 3401.94 1137.77 3410.1 1140.68 3412.31 1149.05 3414.34 1157.1 3412.29 1164.27ZM3412.11 1138.83C3409.9 1130.46 3407.87 1122.41 3409.92 1115.23L3435.44 1143C3428.11 1144.44 3420.27 1141.74 3412.11 1138.83Z",
    stroke: "#2F5597",
    strokeWidth: 1.20928,
    fill: "#2F5597"
  })))), /*#__PURE__*/React.createElement("text", {
    fill: "#2F5597",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 248,
    transform: "matrix(1 0 0 1 2780.69 1322)"
  }, "rug"), /*#__PURE__*/React.createElement("text", {
    fill: "#F7AC34",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 248,
    transform: "matrix(1 0 0 1 3113.56 1322)"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    fill: "#2F5597",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 248,
    transform: "matrix(1 0 0 1 3259.65 1322)"
  }, "LAB"), /*#__PURE__*/React.createElement("path", {
    d: "M2656.52 1148.45 2650.72 1146.49C2646.2 1146.49 2642.53 1149.49 2642.53 1153.19L2642.53 1279.91C2642.53 1283.61 2646.2 1286.61 2650.72 1286.61 2655.25 1286.61 2658.92 1283.61 2658.92 1279.91L2658.92 1153.19C2658.92 1151.34 2658 1149.66 2656.52 1148.45ZM2740.49 1158.16C2757.05 1174.56 2767 1195.59 2767 1218.51 2767 1270.91 2665.78 1312.15 2650.89 1313.38 2636 1314.62 2630.44 1314.2 2627.89 1310.24 2610.16 1267.22 2606.59 1158.5 2626.37 1125.19 2627.89 1122.03 2631.41 1120.69 2650.89 1123.64 2669.11 1126.4 2711.98 1134.26 2732.99 1151.43 2735.62 1153.57 2738.12 1155.82 2740.49 1158.16Z",
    fill: "#F7AC34",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.5412222a7be4b23ea12276db3b562f96.svg";
export { ForwardRef as ReactComponent };